unit U_DateTimeHelper;

interface

uses
  JS, SysUtils, Math, Web;

//function GetJSDateTimeValue(const ADate: TJSDate): Double;
//function JSDateToTDate(const ADate: TJSDate): TDate;
function SafeISO8601ToDate(const AStr: string): TDate;
function SafeISO8601ToTime(const AStr: string): TTime;

implementation

function GetJSDateTimeValue(const ADate: TJSDate): Double;
begin
  Result := ADate.Time;
  // getTime() is essentially the timestamp in milliseconds
end;

// function JSDateToTDate(const ADate: TJSDate): TDate;
// var
// TimeVal: Double;
// TimezoneOffset: Integer;
// begin
// // Get the JavaScript time in milliseconds (UTC)
// TimeVal := GetJSDateTimeValue(ADate) / 86400000.0; // Convert to days
//
// // Get the timezone offset in minutes (note: JavaScript Date gives the difference in minutes from UTC)
// TimezoneOffset := ADate.getTimezoneOffset();
// // returns minutes (positive for UTC+ zones)
//
// // Adjust the date to the local time zone
// Result := TimeVal + EncodeDate(1970, 1, 1) - (TimezoneOffset / 1440);
// // 1440 minutes in a day
// end;
//
// function JSDateToTTime(const ADate: TJSDate): TTime;
// begin
// Result := Frac(JSDateToTDate(ADate));
// end;

function SafeISO8601ToDate(const AStr: string): TDate;
begin
  if AStr <> '' then
    Result := EncodeDate(StrToIntDef(Copy(AStr, 1, 4), 1970),
      StrToIntDef(Copy(AStr, 6, 2), 1), StrToIntDef(Copy(AStr, 9, 2), 1))
  else
    Result := 0;
end;

function SafeISO8601ToTime(const AStr: string): TTime;
var
  h, m, s: Word;
begin
  Result := 0;
  if AStr <> '' then
  begin
    h := StrToIntDef(Copy(AStr, 1, 2), 0);
    m := StrToIntDef(Copy(AStr, 4, 2), 0);
    s := StrToIntDef(Copy(AStr, 7, 2), 0);
    Result := EncodeTime(h, m, s, 0); // No timezone involved
  end;
end;

end.
